import { ResolverTag } from '@ps/web-core-enums';
import { canUseDOM } from '@ps/web-core-utils';
import type { Middleware } from 'redux';

import { dispatch, select } from '..';
import type { RootState } from '../types';

const authLoginMiddleware: Middleware<object, RootState> = (storeApi) => (next) => (action) => {
  const rootState = storeApi.getState();
  const isEmbedded = rootState.device.embedded;
  const isOpeningLoginModal =
    ['modal/enqueue', 'modal/replace', 'modal/unshift'].includes(action.type) &&
    action.payload.path === '/auth/login';

  if (isOpeningLoginModal && isEmbedded) {
    window?.starsweb?.auth.login();
    return;
  }

  if (isOpeningLoginModal && action.type.startsWith('modal/')) {
    const isExternalPartnerSite = select.cms.isExternalPartnerSite(rootState);
    const href = select.location.getHref(rootState);

    if (canUseDOM && isExternalPartnerSite) {
      (async () => {
        let psnAuthLoginUrlTag = select.resolver.getTag(rootState, ResolverTag.PsnAuthLoginUrl);

        if (!psnAuthLoginUrlTag) {
          await dispatch.resolver.fetchTag({
            tag: ResolverTag.PsnAuthLoginUrl,
            site: select.cms.getSiteId(rootState),
            query: {
              redirect_uri: href
            }
          });
          psnAuthLoginUrlTag = select.resolver.getTag(
            storeApi.getState(),
            ResolverTag.PsnAuthLoginUrl
          );
        }

        if (typeof psnAuthLoginUrlTag?.url === 'string' && psnAuthLoginUrlTag.url.trim() !== '') {
          window.location.assign(psnAuthLoginUrlTag.url);
        } else {
          // eslint-disable-next-line no-console
          console.error('Invalid or missing URL in psnAuthLoginUrlTag:', psnAuthLoginUrlTag);
        }
      })();

      return;
    }
  }

  return next(action);
};

export default authLoginMiddleware;
